export const serverEnvironment = {
  apiBeta822: 'https://api-beta822.aaaauto.cz',
  apiV2: 'https://api-v2.aaaauto.cz',
  apiNg: 'http://api-ng.aaaauto.cz',
  apiBeta74: 'https://api-beta74.autox.cz',
  apiDev1: 'https://api-dev1.aaaauto.cz',
  carsApi: 'https://api-beta822.aaaauto.cz/v2/frontend/cars/car/search',
  accessoriesList: '/api/accessories',
};
